import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MetalRatesService {


  url = environment.serverAPI4 + "/api/metalRates";

  constructor(private http: HttpClient) { }

  getAllMetalRates(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllMetalRatesDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getMetalRatesById(metalRateId: number): Observable<Object> {
    return this.http.get(`${this.url}/${metalRateId}`);
  }

  addOrEditMetalRates(metalRates: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, metalRates);
  }

  metalRatesSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  sync(): Observable<Object> {
    return this.http.get(`${this.url}/sync`);
  }


}
